/** Dev server deploy: same backend host as production. */
export const API_BASE = 'https://pdadigital.svayamtech.com:3044/api/v1/smart-building-check';
export const FILES_BASE = 'https://pdadigital.svayamtech.com:3044/files';
